import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Skeleton } from "@/components/wei/Section";

export function PanelQueue() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/engine/panels").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const decide = async (id, status) => { try { await api.patch(`/admin/engine/panels/${id}`, { status, note: "" }); toast.success(`Panel member ${status}`); load(); } catch (e) { toast.error(errorMessage(e)); } };
  if (!items) return <Skeleton className="h-32" />;
  return (
    <section className="wei-card p-5" data-testid="panel-queue">
      <h3 className="font-semibold">Industry Panel applications</h3>
      {!items.length ? <p className="text-sm text-[#8A867E] mt-2" data-testid="panel-queue-empty">No applications yet.</p> : (
        <ul className="divide-y divide-[#EFEDE8] mt-2">{items.map((m) => <li key={m.id} className="py-3 flex items-center justify-between gap-3 text-sm" data-testid={`panel-item-${m.id}`}>
          <div><div className="font-medium">{m.name || m.email} <span className="text-xs text-[#6B675F]">· {m.field}</span></div><div className="text-xs text-charcoal">{m.credentials}</div></div>
          <div className="flex items-center gap-2"><span data-testid={`panel-status-${m.id}`} className="text-[10px] uppercase tracking-wider font-semibold px-2 py-1 rounded-sm bg-stone">{m.status}</span>
            {m.status === "pending" && <><button data-testid={`panel-approve-${m.id}`} onClick={() => decide(m.id, "approved")} className="btn-gold btn-sm">Approve</button><button data-testid={`panel-decline-${m.id}`} onClick={() => decide(m.id, "declined")} className="btn-outline btn-sm">Decline</button></>}
            {m.status === "approved" && <button data-testid={`panel-suspend-${m.id}`} onClick={() => decide(m.id, "suspended")} className="btn-outline btn-sm text-bordeaux">Suspend</button>}</div>
        </li>)}</ul>
      )}
    </section>
  );
}

export function ConflictList() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/engine/conflicts").then((r) => setItems(r.data)); }, []);
  if (!items) return <Skeleton className="h-32" />;
  return (
    <section className="wei-card p-5" data-testid="conflict-list">
      <h3 className="font-semibold">Flagged conflicts of interest</h3>
      <p className="text-xs text-[#6B675F] mt-1">Nominations excluded from the Industry stream. Nominator identities stay private outside this console.</p>
      {!items.length ? <p className="text-sm text-[#8A867E] mt-2" data-testid="conflicts-empty">No conflicts flagged.</p> : (
        <ul className="divide-y divide-[#EFEDE8] mt-2 text-sm">{items.map((n) => <li key={n.id} className="py-2" data-testid={`conflict-${n.id}`}><Link to={`/registry/${n.profile_slug}`} className="font-medium hover:text-bordeaux">{n.profile_slug}</Link> <span className="text-xs text-bordeaux">· {n.conflict}</span><div className="text-[11px] text-[#6B675F]">{n.field} · {n.created_at?.slice(0, 10)}</div></li>)}</ul>
      )}
    </section>
  );
}
